export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtCasw';
export const NAME = 'WCas';
